import { Icon, Page, PathButton } from "shared/react";
import { useCreatorContext } from "./CreatorContext.js";
import { EntityHeader } from "../entity/EntityHeader.js";
import { VerifiedCondition } from "./VerifiedCondition.js";

export function CreatedPage(): React.ReactElement {
	const creator = useCreatorContext();
	return (
		<Page title="Created content" path="./create">
			<EntityHeader entity={creator}>
				<h1>Created content</h1>
			</EntityHeader>
			<nav className="grid grid-half gap-xsmall">
				<PathButton path="../challenges" mods="flex-column flex-center pad-2x">
					<Icon icon="challenge" mods="size-2x" /> <span>Challenges</span>
				</PathButton>
				<PathButton path="../badges" mods="flex-column flex-center pad-2x">
					<Icon icon="badge" mods="size-2x" /> <span>Badges</span>
				</PathButton>
				<PathButton path="../backgrounds" mods="flex-column flex-center pad-2x">
					<Icon icon="background" mods="size-2x" /> <span>Backgrounds</span>
				</PathButton>
				<VerifiedCondition entity={creator}>
					<PathButton path="../reactions" mods="flex-column flex-center pad-2x">
						<Icon icon="reaction" mods="size-2x" /> <span>Reactions</span>
					</PathButton>
				</VerifiedCondition>
				<PathButton path="../notes" mods="flex-column flex-center pad-2x">
					<Icon icon="note" mods="size-2x" /> <span>Notes</span>
				</PathButton>
				<PathButton path="../lists" mods="flex-column flex-center pad-2x">
					<Icon icon="list" mods="size-2x" /> <span>Lists</span>
				</PathButton>
			</nav>
		</Page>
	);
}
